<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <h2 class="white--text ma-5">【AI給餌モニタリング】</h2>
        <v-card elevation="24" class="mb-3">
            <v-toolbar color="indigo" dark>
                <v-toolbar-title class="font-weight-bold">{{ dbDevice.name }}</v-toolbar-title>
                <h4 class="white--text">( {{ dbCamera.name }} )</h4>
            </v-toolbar>
            <v-card-text class="pa-0">
                <v-responsive :aspect-ratio="16 / 9">
                    <img :src="jpgImg" width="100%" style="aspect-ratio: 16 / 9; object-fit: contain; background-color: lightgray" />
                    <!--
                    <v-img fluid :src="jpgImg">
                        <h4 class="white--text">{{ dbCamera.name }}</h4>
                    </v-img>
                    -->
                    <!--
                    <img :src="jpgImg" style="width: 100%; height: auto" />
                    -->
                </v-responsive>
            </v-card-text>
        </v-card>
        <h5>AI給餌中の時間帯のみ、閲覧できます。</h5>
        <h5>過去の画像は、タイムラプス画面をご覧ください。</h5>
    </v-container>
</template>

<script>
import Config from "@/config.json";
import mqtt from "mqtt";
export default {
    name: "LiveAiCam",
    data() {
        return {
            jwt: "",
            device_id: 0,
            camera_id: 0,
            dbDevice: { id: 0, name: "" },
            dbCamera: { id: 0, name: "" },
            jpgImg: "",
            noImage: require("@/assets/no-image.jpg"),
            isLoading: false,
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mqttClient: { connected: false },
            //-----------------------------
        };
    },
    //===========================================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        this.device_id = this.$route.params.device_id;
        this.camera_id = this.$route.params.camera_id;
        this.jpgImg = this.noImage;
        //-----------------------
        //非同期でAxiosGet
        const promiseDevice = this.axiosGetDevices();
        const promiseCamera = this.axiosGetCameras();
        //-----------------------
        //上記の終了を待つ
        await promiseDevice;
        await promiseCamera;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.isLoading = false;
        //-----------------------
        this.connectMqtt();
        //-----------------------
        window.scrollTo(0, 0);
    },
    //========================================================
    beforeDestroy: async function () {
        this.disconnectMqtt();
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { id: this.device_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevice = response.data.json[0];
            });
        },
        //===================================================
        async axiosGetCameras() {
            await this.axios({
                method: "GET",
                url: "/web/api/cameras",
                params: { id: this.camera_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(async (response) => {
                this.dbCamera = response.data.json[0];
            });
        },
        //====================================================
        async connectMqtt() {
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("MQTT Connected !!");
            });
            //-----------------
            this.mqttClient.on("message", function (topic, message) {
                let subMsg = message.toString();
                let obj = JSON.parse(subMsg);
                if (obj.camera_id && obj.camera_id == gThis.dbCamera["id"]) {
                    if (obj.shot) gThis.jpgImg = obj.shot;
                    if (obj.countDown) gThis.jpgCountDown = obj.countDown;
                }
            });
            //-----------------
            //const mac = this.dbDevice["mac"];
            this.mqttClient.subscribe(this.mqttTopicSub + "/ai-shot/" + this.camera_id);
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
        },
        //====================================================
    },
};
</script>
